const { request } = require("../../rest");

const verifyRecaptcha = (token) =>
  request.post(
    "/website-api/v1/recaptcha/verify",
    { token },
    { headers: { "content-type": "application/json" } }
  );

module.exports = verifyRecaptcha;
